import { atom } from 'jotai';

// Sidebar collapsed state
export const sidebarCollapsedAtom = atom(false);

// Sidebar hover state for tooltip display
export const sidebarHoveredAtom = atom(false);
